import { DragEvent, DragEventHandler } from "react";
import { Card, CardContent } from "@mui/material";
import { CRMCardDeals } from "../../customwidgets/leads-crm/CRMCardDeals";

export const DragCard = ({ item, dragAction, cardType, cardProps }: any) => {
    const handleDragStart: DragEventHandler<HTMLDivElement> = (
        event: DragEvent
    ) => {
        const cardData = item;
        event.dataTransfer.setData("text", JSON.stringify(cardData));
        dragAction(cardData);
    };

    return (
        <Card key={item["uuid"]} draggable="true" onDragStart={handleDragStart} style={{ padding: 10, marginBottom: 10 }}>
            <CardContent>
                {cardType === "CRMCardDeals" && (
                    <CRMCardDeals item={item} cardProps={cardProps} />
                )}
            </CardContent>
        </Card>
    );
};
